import Entity from '../entity'

export default class Projection extends Entity<number>{
    dealer_id: number;
    vehicle_type_id: number;
    concept_id: number;
    year: number;
    month: number;
    amount: number;
}


